// extracted by mini-css-extract-plugin
export default {"postContainer":"_mediaHomeModal_postContainer__8SCfc","close":"_mediaHomeModal_close__yzFhG"};